module.exports = __webpack_public_path__ + "static/img/COC2023-13.19db9ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-13.png
// module id = QwE9
// module chunks = 0